var React = require('react');

function PhoneFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M29.304 46a12.58 12.58 0 006.759 2 12.499 12.499 0 008.878-3.699l1.55-1.549a5.197 5.197 0 000-7.337l-6.52-6.507a5.19 5.19 0 00-7.338 0 2.18 2.18 0 01-1.55.64 2.21 2.21 0 01-1.55-.64L19.107 18.472a2.199 2.199 0 010-3.098 5.187 5.187 0 000-7.327l-6.519-6.528a5.2 5.2 0 00-7.338 0L3.7 3.069a12.504 12.504 0 00-1.68 15.683 100.968 100.968 0 0027.225 27.249h.06z"}));
}

PhoneFilled.defaultProps = {"viewBox":"0 0 49 48"};

module.exports = PhoneFilled;

PhoneFilled.default = PhoneFilled;
